import styled from "styled-components";

export const StyledHero = styled.div`
  min-height: 100vh;
  width: 100vw;
  background: black;
  overflow: hidden;
  .swiper-container  {
    padding: 1rem;
  }
`;

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  z-index: 20;
  max-width: 100vw;
  width: 100%;
  @media screen and (min-width: 1024px) {
    max-width: 1000px;
  }
`;

export const BigCointainer = styled.div`
  position: relative;
  margin: 0 auto;
  z-index: 20;
  max-width: 100vw;
  width: 100%;
  @media screen and (min-width: 1024px) {
    max-width: 1300px;
  }
`;

export const Mask = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, transparent 0%, #000 80%, #000 100%);
  z-index: 15;
`;

export const StyledPunkCard = styled.div`
  background: radial-gradient(
    circle,
    transparent 0%,
    rgba(30, 176, 235, 1) 80%,
    rgba(30, 176, 235, 1) 100%
  );
  border: 2px solid #92defc;
  box-shadow: 5px 5px 15px rgba(30, 176, 235, 1);
  max-width: 15rem;
  padding: 2rem;

  perspective: 1000px;
  transform: rotateY(-12deg);

  transition: all 2s;
  animation-name: neon;
  animation-duration: 5s;
  animation-iteration-count: infinite;

  img {
    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.8);
  }
  @media screen and (min-width: 1024px) {
    max-width: 20rem;
  }
`;

export const Perspective = styled.div`
  perspective: 1000px;
  h1 {
    position: absolute;
    text-align: center;
    left: 0;
    width: 100%;
    top: 0;
    transform: translate(0, -4rem);
  }
`;

export const Button = styled.button`
  position: relative;
  border-radius: 3px;
  border: 2px solid #92defc;
  box-shadow: 5px 5px 15px rgba(30, 176, 235, 1);
  background: rgba(0, 0, 0, 0.6);
  color: #92defc;
  padding: 0.5rem 1rem;
  transition: all 2s;
  animation-name: neon;
  animation-duration: 5s;
  animation-iteration-count: infinite;
`;

export const GreenButton = styled.button`
  //background: #7feb7a;
  color: #fff;
  position: relative;
  border-radius: 3px;
  padding: 0.2rem 0.5rem;
  transition: all 2s;
  font-size: 14px;
  border: 2px solid #92defc;
  box-shadow: 5px 5px 15px rgba(30, 176, 235, 1);
`;

export const GreyBackground = styled.div`
  background: #0c0d10;
`;

export const SytledArrows = styled.div`
  .arrow {
    position: absolute;
    top: 50%;
    font-size: 2rem;
    &.left {
      left: 0;
      transform: translate(-2rem, -50%);
    }
    &.right {
      right: 0;
      transform: translate(2.5rem, -50%);
    }
  }
`;
